module.exports = __webpack_public_path__ + "static/img/22.10a3af0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mimg/22.jpg
// module id = QB4z
// module chunks = 3 4